// config.js
const CONFIG = {
  API_URL: "https://apitest.instanttranscriber.com:443",
  //API_URL: "http://127.0.0.1:5001",
  CREATE_CHECKOUT_SESSION: "https://rznoswutcndebmpeezuz.supabase.co/functions/v1/create-checkout-session",
  CREATE_BILLINGPORTAL_SESSION: "https://rznoswutcndebmpeezuz.supabase.co/functions/v1/create-billingportal-session",
};

module.exports = CONFIG;
